import {Button, ButtonProps, CircularProgress} from '@material-ui/core';
import {Async, isLoaded} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';

type AsyncButtonProps = {
  data: Async<unknown>;
} & ButtonProps;

const AsyncButton = (props: AsyncButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLoaded(props.data)) {
      setIsLoading(false);
    }
  }, [props.data]);

  return !isLoaded(props.data) && isLoading ? (
    <CircularProgress className="file-download-button__loading" />
  ) : (
    <Button
      {...props}
      onClick={e => {
        if (props.onClick) {
          props.onClick!(e);
        }
        setIsLoading(true);
      }}
    >
      {props.children}
    </Button>
  );
};

export default AsyncButton;
